module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "set-position",
    staticStyle: {
      "width": "100%",
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "footer-left pull-left"
  }, [_c('div')]), _vm._v(" "), _c('div', {
    staticClass: "footer-right pull-right"
  }, [_c('div', {
    attrs: {
      "id": "footer-phone"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "static/imgs/footer-phone.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("服务电话：023-81398683\n        ")]), _vm._v(" "), _c('p', [_vm._v("服务时间：周一至周五 上午9:00至下午17:00")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd98db56","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/G-footer.vue
// module id = 27
// module chunks = 1 5 6 7 8 9 10 11 12 13 14 15